import React from "react";
import {
  GraduationCap,
  Lightbulb,
  Zap,
  TrendingUp,
  Cpu,
  Briefcase,
  Settings,
  ShieldCheck,
} from "lucide-react";

const audiences = [
  {
    icon: GraduationCap,
    title: "Students",
    desc: "Academic and final-year innovation projects.",
  },
  {
    icon: Lightbulb,
    title: "Individual Innovators",
    desc: "Turn an idea into a technically viable product.",
  },
  {
    icon: Zap,
    title: "Startups",
    desc: "Design validation, product development, prototype planning.",
  },
  {
    icon: TrendingUp,
    title: "Entrepreneurs",
    desc: "Evaluate product feasibility and manufacturing options.",
  },
  {
    icon: Cpu,
    title: "Researchers",
    desc: "Technical design, testing and prototype development.",
  },
  {
    icon: Briefcase,
    title: "MSMEs",
    desc: "Improve existing products and develop new ones.",
  },
  {
    icon: Settings,
    title: "Industries",
    desc: "Redesign, engineering optimisation and advanced manufacturing.",
  },
  {
    icon: ShieldCheck,
    title: "Government Orgs",
    desc: "Technical consultation and innovation projects.",
  },
];

export default function WhoItsFor() {
  return (
    <section className="w-full bg-[#f5f6f8]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
        {/* Eyebrow */}
        <p className="text-[11px] sm:text-xs tracking-[0.2em] font-semibold text-amber-500 uppercase mb-5">
          Who It&apos;s For
        </p>

        {/* Headline */}
        <h2 className="font-serif text-[#0d1526] leading-[1.1] text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] max-w-3xl">
          Who can consult our experts?
        </h2>

        {/* Grid */}
        <div className="mt-12 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {audiences.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="rounded-2xl border border-black/10 bg-white p-6 sm:p-7 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
            >
              <div className="w-11 h-11 rounded-xl bg-amber-100 flex items-center justify-center mb-6">
                <Icon className="w-5 h-5 text-[#0d1526]" strokeWidth={1.75} />
              </div>
              <h3 className="font-semibold text-[#0d1526] text-lg sm:text-xl mb-2">
                {title}
              </h3>
              <p className="text-slate-500 text-sm sm:text-base leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}